import React from "react";
import Terminate from "./common/Terminate";
import FreezeCard from "./common/FreezeCard";

const ManageCardDesktop = ({
  user,
  roles,
  isRiskLocked,
  resetSuccess,
  SettingsButton,
  SettingsInputContainer,
}) => {
  if (isRiskLocked) {
    return null;
  }

  return (
    <div className="mt-4 flex">
      <FreezeCard
        user={user}
        roles={roles}
        SettingsButton={SettingsButton}
        SettingsInputContainer={SettingsInputContainer}
        resetSuccess={resetSuccess}
      />

      {(roles || {}).admin ? (
        <Terminate
          user={user}
          roles={roles}
          SettingsButton={SettingsButton}
          SettingsInputContainer={SettingsInputContainer}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default ManageCardDesktop;
